/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Test
 * test for applicants to analytics team
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApplicantLoginPayloadRequest
 */
export interface ApplicantLoginPayloadRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplicantLoginPayloadRequest
     */
    code: string;
}

/**
 * Check if a given object implements the ApplicantLoginPayloadRequest interface.
 */
export function instanceOfApplicantLoginPayloadRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "code" in value;

    return isInstance;
}

export function ApplicantLoginPayloadRequestFromJSON(json: any): ApplicantLoginPayloadRequest {
    return ApplicantLoginPayloadRequestFromJSONTyped(json, false);
}

export function ApplicantLoginPayloadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicantLoginPayloadRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
    };
}

export function ApplicantLoginPayloadRequestToJSON(value?: ApplicantLoginPayloadRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
    };
}

